// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","flagIcon":"_3Y4wiOYGznIaT9priHTXHj","flagged":"LRr56jMCwgHdTCVA0C3iy","flagCompensation":"_14FaOxXz_TStxZLYjtxTDP"};